import React, { useState } from "react";
import { Save as SaveIcon } from "@mui/icons-material";
import Modal from "@components/common/Modal/Modal";
import Button from "@components/common/Button/Button";
import CustomSelect from "@components/common/Select/Select";
import { sessionSelectClassName } from "@config/theme/formControls";
// import { useTranslation } from "react-i18next";

interface CustomizeChallanModalProps {
	isOpen: boolean;
	onClose: () => void;
}

const CustomizeChallanModal: React.FC<CustomizeChallanModalProps> = ({ isOpen, onClose }) => {
	// const { t } = useTranslation();
	const [selectedSession, setSelectedSession] = useState("2024-2025");
	const [selectedPrice, setSelectedPrice] = useState("");

	// Wrapper functions to handle string | number values
	const handleSessionChange = (value: string | number) => {
		setSelectedSession(String(value));
	};

	const handlePriceChange = (value: string | number) => {
		setSelectedPrice(String(value));
	};

	const sessionOptions = [
		{ value: "", label: "Select Session", isPlaceholder: true },
		{ value: "2024-2025", label: "2024-2025" },
		{ value: "2025-2026", label: "2025-2026" },
		{ value: "2026-2027", label: "2026-2027" },
	];
	const priceOptions = [
		{ value: "", label: "Select Price", isPlaceholder: true },
		{ value: "5000", label: "5000" },
		{ value: "10000", label: "10000" },
		{ value: "15000", label: "15000" },
	];

	const courseTypes = [
		{ key: "vocational", label: "Vocational Courses", color: "text-primary" },
		{ key: "technical", label: "Technical Courses", color: "text-primary" },
		{ key: "both", label: "Both", color: "text-primary" },
	];

	const handleSaveChanges = () => {
		// TODO: Implement save functionality
		onClose();
	};

	const footer = (
		<div className="flex justify-end">
			<Button
				onClick={handleSaveChanges}
				variant="primary"
				className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-2 rounded-lg flex items-center gap-2">
				<SaveIcon className="w-4 h-4" />
				Save Changes
			</Button>
		</div>
	);

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Customize Challan"
			width="max-w-2xl"
			height="auto"
			padding="p-6"
			footer={footer}>
			{/* Set Session Section */}
			<div className="space-y-4">
				<div className="text-lg font-semibold text-gray-800">Set Session</div>
				<div className={sessionSelectClassName}>
				<CustomSelect
					options={sessionOptions}
					selected={selectedSession}
					setSelected={handleSessionChange}
					placeholder="Select Session"
					id="session-select"
				/>
				</div>
			</div>

			{/* Set Price For Courses Section */}
			<div className="space-y-4 mt-8">
				<div className="text-lg font-semibold text-gray-800">Set Price For Courses</div>
				<div className="space-y-4">
					{courseTypes.map(courseType => (
						<div
							key={courseType.key}
							className="flex items-center justify-between p-4 bg-white rounded-lg border border-gray-200">
							<div className={`font-medium ${courseType.color}`}>{courseType.label}</div>
							<div className="w-40">
								<CustomSelect
									options={priceOptions}
									selected={selectedPrice}
									setSelected={handlePriceChange}
									placeholder="Select Price"
									id={`${courseType.key}-price-select`}
								/>
							</div>
						</div>
					))}
				</div>
			</div>
		</Modal>
	);
};

export default CustomizeChallanModal;
